var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoArrowDropdownUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8 3.56667L9.3 6.9C9.79443 7.55924 9.32404 8.5 8.5 8.5L3.5 8.5C2.67595 8.5 2.20557 7.55924 2.7 6.9L5.2 3.56667C5.6 3.03333 6.4 3.03333 6.8 3.56667Z",
    fill: "#FF2727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrowDropdownUp);
export default __webpack_public_path__ + "static/media/ico_arrow_dropdown_up.b50d3d1ccd932d45356f625c301da1b4.svg";
export { ForwardRef as ReactComponent };